/*
 * Copyright (c) 2017 DV Bern AG, Switzerland
 *
 * Das vorliegende Dokument, einschliesslich aller seiner Teile, ist urheberrechtlich
 * geschuetzt. Jede Verwertung ist ohne Zustimmung der DV Bern AG unzulaessig. Dies gilt
 * insbesondere fuer Vervielfaeltigungen, die Einspeicherung und Verarbeitung in
 * elektronischer Form. Wird das Dokument einem Kunden im Rahmen der Projektarbeit zur
 * Ansicht uebergeben ist jede weitere Verteilung durch den Kunden an Dritte untersagt.
 *
 */
import TSAbstractEntity from './TSAbstractEntity';
import {TSSerializable} from './TSSerializable';
import {TSVorleistungArt} from './enums/TSVorleistungArt';

export default class TSVorleistungDaten extends TSAbstractEntity implements TSSerializable<TSVorleistungDaten> {

    private _vorleistungenArt: TSVorleistungArt;

    private _betrag: number;
    private _berechtigterBetrag: number;

    private _policeNr: string;

    public get policeNr(): string {
        return this._policeNr;
    }

    public set policeNr(value: string) {
        this._policeNr = value;
    }

    public get betrag(): number {
        return this._betrag;
    }

    public set betrag(value: number) {
        this._betrag = value;
    }

    public get berechtigterBetrag(): number {
        return this._berechtigterBetrag;
    }

    public set berechtigterBetrag(value: number) {
        this._berechtigterBetrag = value;
    }

    public get vorleistungenArt(): TSVorleistungArt {
        return this._vorleistungenArt;
    }

    public set vorleistungenArt(value: TSVorleistungArt) {
        this._vorleistungenArt = value;
    }

    deserialize(restObject: any): TSVorleistungDaten {
        super.deserialize(restObject);
        this.vorleistungenArt = restObject.vorleistungenArt;

        this.policeNr = restObject.policeNr;
        this.betrag = restObject.betrag;
        this.berechtigterBetrag = restObject.berechtigterBetrag;
        return this;
    }

    serialize(restObject: any): any {
        super.serialize(restObject);

        restObject.vorleistungenArt = this.vorleistungenArt;
        restObject.policeNr = this.policeNr;
        restObject.betrag = this.betrag;
        restObject.berechtigterBetrag = this.berechtigterBetrag;

        return restObject;
    }
}



// WEBPACK FOOTER //
// ./src/app/models/TSVorleistungDaten.ts